module.exports = __webpack_public_path__ + "img/necesitas_three.05ca3547.png";